module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_phone_number_usage-2fcb08cb3e3beff05860dd034feda37f.png";